import { Block, Fragment, Text } from '@gitbook/slate';

import { BLOCK_PARAGRAPH } from '../types';

/**
 * Creates an empty fragment.
 */
export function createTextFragment(
    params: { fragment?: string; type?: string; text?: string } = {}
) {
    return Fragment.create({
        fragment: params.fragment,
        type: params.type,
        nodes: [
            Block.create({
                type: BLOCK_PARAGRAPH,
                nodes: [Text.create(params.text || '')],
            }),
        ],
    });
}
